<div class="mx-auto pb-5">
  <app-text-atom [content]="content"></app-text-atom>
</div>
